export const HOME_HANDLE = 'home';
